<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <article class="media">
                    <div class="media-content">
                        <div class="content">
                            <h3 v-if="getTransactionType == 3" class="title has-text-danger has-text-centered">RETURN MONEY TO DEPOSIT?</h3>
                            <h3 v-else class="title has-text-danger has-text-centered">DELETE THIS TRANSACTION?</h3>
                            <div class="has-text-centered" v-if="getTransactionType == 3">
                                <a class="button is-primary" @click="deleteThisTransaction('yes')">Yes</a>
                                <a class="button is-danger" @click="deleteThisTransaction('no')">No</a>
                            </div>
                            <div class="has-text-centered" v-else>
                                <a class="button is-primary" @click="deleteThisTransaction('no')">Yes</a>
                                <a class="button is-danger" @click="closeModal()">No</a>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
</template>

<script>
    export default {
        props: ['car'],
        data() {
            return {
                transactionId: this.getTransactionId
            }
        },
        computed: {
            isActive() {
                return this.$store.getters.getTransactionDeleteModalStatus
            },
            getTransactionId(){
                return this.$store.getters.getTransactionId
            },
            getTransactionType(){
                return this.$store.getters.getBTransactionType
            }
        },
        methods: {
            closeModal () {
                this.$store.commit('setTransactionDeleteModalStatus', false)
                this.$store.commit('setTransactionDeleteId', '')
                this.$store.commit('setBTransactionType', '')
            },
            deleteThisTransaction (isDelete) {
                const data = {is_deleted: isDelete, transaction_id: this.$store.getters.getTransactionId}
                this.$store.dispatch('deleteTransactionById', data)
                //this.$router.push('/cars')
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Banking/DeleteTransactionModal.vue